/**
 * Cives Hub Backend Authentication API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface PraticheCittadinoCountersDTO { 
    da_completare?: number;
    in_valutazione?: number;
    accettata?: number;
    rifiutata?: number;
    totale?: number;
}

